/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { useSelector } from 'react-redux';
import { AppRootState } from 'src/store';

interface DocumentViewerProps { }

const DocumentViewer = function DocumentViewer(props: DocumentViewerProps) {
  console.log(props);
  const documentViewerState = useSelector((state: AppRootState) => state.documentViewer);
  console.log(documentViewerState);
  return (
    <div>
      DocumentViewer
    </div>
  );
};

DocumentViewer.defaultProps = {

};

DocumentViewer.propTypes = {

};

export default DocumentViewer;
